<template>
	<BaseCmsPage @load="onPageLoad">
		<CmsCheckoutWrapper>
			<ClientOnly>
				<BaseForm @submit="onSubmit" v-slot="{meta}">
					<div class="wc-form wc-payment-second-form floating-labels-checkout floating-labels">
						<div class="wc-form-col1">
							<div class="wc-title" :class="{'special': orderData && orderData.cart.payments.selected[0].id == idNumber}">
								<template v-if="orderData && orderData.cart.payments.selected[0].id == 34"><BaseCmsLabel code="payment_second_form_diners_title" /></template>
								<template v-else-if="orderData && orderData.cart.payments.selected[0].id == 31"><BaseCmsLabel code="payment_second_form_title_short" /> {{ orderData.cart.payments.selected[0].title }}</template>
								<template v-else-if="orderData && orderData.cart.payments.selected[0].id == idNumber"><img src="/images/flik.png" width="50" height="50" alt="" /><BaseCmsLabel code="payment_second_form_flik_title" /></template>
								<template v-else-if="orderData && orderData.cart.indicators.payment_cart_type"
									><BaseCmsLabel code="payment_second_form_title_short" /> <span style="text-transform: capitalize">{{ orderData.cart.indicators.payment_cart_type }}</span></template
								>
								<template v-else><BaseCmsLabel code="payment_second_form_title" /></template>
							</div>

							<div v-if="paymentError" class="unavailable-item special">
								<div class="title"><strong v-html="error_message"></strong></div>
								<div class="btn-hidde" @click="hiddeErrorMessage()">
									<span><BaseCmsLabel code="hidde_error" /></span>
								</div>
							</div>

							<div class="wc-subtitle" v-if="paymentgateway && paymentgateway.pg_mode == 'cc'"><BaseCmsLabel code="credit_card_data" /></div>
							<div class="wc-fields" :class="{'special': orderData && orderData.cart.payments.selected[0].id == idNumber}">
								<template v-for="field in creditCard" :key="field.name">
									<BaseFormField :item="field" v-slot="{errorMessage, value, isTouched, floatingLabel}">
										<div class="input-field field" :class="['input-field-'+field.name, {'field-error': errorMessage && isTouched, 'field-success': !errorMessage && value, 'floated-label': floatingLabel}]">
											<BaseFormInput :id="field.name + '-1'" />
											<label :for="field.name"><BaseCmsLabel :code="field.name" /></label>
											<span class="error" v-show="errorMessage" v-html="errorMessage" />
										</div>
									</BaseFormField>
								</template>

								<template v-if="paymentgateway && paymentgateway.pg_mode == 'phone_email' && labels.get('flik_note')">
									<BaseCmsLabel code="flik_note" tag="span" class="wc-fields-note" />
								</template>

								<template v-if="paymentgateway && paymentgateway.pg_mode == 'cc'">
									<div class="input-field">
										<label id="bankartNumberLabel" class="bankart-label" for="number_div"><BaseCmsLabel code="cc_number" /></label>
										<div class="pef-cc-field-container" id="cc_number"></div>
										<span class="error error_cc_number" id="error_cc_number" style="display: none">
											<span v-if="orderData?.cart && orderData?.cart?.indicators?.payment_cart_type && cardTypeValue == false" v-html="labels.get('bankart_error_cc_number_card').replace('%c%', (orderData?.cart?.indicators?.payment_cart_type).toUpperCase())"></span>
											<template v-else><BaseCmsLabel code="bankart_error_cc_number" /></template>
										</span>
									</div>

									<div class="input-field">
										<input type="tel" pattern="[0-9]{2}/[0-9]{2}" id="exp_month_year" name="exp_month_year" maxlength="5" value="" placeholder=" " />
										<label for="exp_month_year"><BaseCmsLabel code="cc_expire" /></label>
										<span class="error" id="error_exp_month_year" style="display: none"><BaseCmsLabel code="bankart_error_cc_expire" /></span>
									</div>

									<div class="input-field">
										<label id="bankartCvvLabel" class="bankart-label" for="number_div"><BaseCmsLabel code="cc_cvv" /></label>
										<div class="pef-cc-field-container" id="cc_cvv"></div>
										<div class="cvv-info-label"><BaseCmsLabel code="cvv_info" /></div>
										<span class="error error_cvv" id="error_cvv" style="display: none"><BaseCmsLabel code="bankart_error_cc_cvv" /></span>
									</div>

									<input type="hidden" name="transaction_token" id="transaction_token" />
									<input type="hidden" name="order_id" id="order_id" :value="paymentgateway.order_id" />
									<input type="hidden" name="hold_url" id="hold_url" :value="paymentgateway.payment_hold_url" />
									<input type="hidden" name="cancel_url" id="cancel_url" :value="paymentgateway.cancel_url" />
									<input type="hidden" name="shared_key" id="shared_key" :value="paymentgateway.shared_key" />
								</template>
							</div>
						</div>

						<WebshopSidebarBankart :meta="meta" review="true" mode="total_full" />
						<WebshopWidgetFixedbarBankart review="true" :meta="meta" mode="total_full" />
					</div>
				</BaseForm>
				<template #fallback>
					<BaseThemeUiLoading />
				</template>
			</ClientOnly>
		</CmsCheckoutWrapper>
	</BaseCmsPage>
</template>

<script setup>
	import {useForm, useValidateForm} from 'vee-validate';

	const {meta} = useForm();
	const config = useAppConfig();
	const validateForm = useValidateForm();
	const apiRoutes = useApiRoutes();
	const webshop = useWebshop();
	const endpoints = useEndpoints();
	const labels = useLabels();
	const { checkoutLoading, orderData, paymentError, formValid, creditCard, dateValid, cardNumberValid, cvvValid, paymentgateway, additionalPayment, additionalPaymentRoute, orderSuccess } = useCheckout();

	checkoutLoading.value = false;
	cardNumberValid.value = 0;
	cvvValid.value = 0;
	const origin = config.host == 'https://www.bigbang.si' || config.host == 'https://beta.bigbang.si' ? true : false;
	const idNumber = ref(origin ? 36 : 40);
	const cardTypeValue = ref(true);

	async function validationBankart() {
		await validateForm();
	}

	// watch if form is valid
	watchEffect(
		() => (formValid.value = (paymentgateway.value && paymentgateway.value.pg_mode == 'phone_email') || (paymentgateway.value && paymentgateway.value.pg_mode == 'cc' && cardNumberValid.value && cvvValid.value && dateValid.value) ? 1 : 0),
	);

	//bankart script
	function bankartScript() {
		let s = document.createElement('script');
		function setAttributes(el, attrs) {
			for (var key in attrs) {
				el.setAttribute(key, attrs[key]);
			}
		}
		setAttributes(s, {'data-main': 'payment-js', 'src': paymentgateway.value.script_url});
		document.head.appendChild(s);
	}

	//hidde error message
	function hiddeErrorMessage() {
		paymentError.value = null;
	}

	//error message
	let error_message = computed(() => {
		let error_code_message = paymentError.value != null ? paymentError.value.error_code : null;
		let error_code = error_code_message ? error_code_message.replace('error_paid_', '') : null;
		if (error_code) {
			let payment_errors = labels.get('bankart_error_codes');
			let payment_errors_split = payment_errors.split('\n');
			let message;

			payment_errors_split.forEach(el => {
				let [payment_error_code, payment_error_message] = el.split('|');
				if (payment_error_code == error_code) {
					message = payment_error_message;
				}
			});

			if (!message) {
				message = labels.get('bankart_error_code_generic');
			}

			return message;
		} else if (paymentError.value && paymentError.value.label_name) {
			return labels.get(paymentError.value.label_name);
		}
	});

	//bankart interval
	let bankartInterval;
	onMounted(() => {
		bankartInterval = setInterval(function () {
			if (typeof PaymentJs === 'function' && paymentgateway.value && paymentgateway.value.pg_mode == 'cc') {
				const cc_number_element_new = document.getElementById('cc_number');
				if (cc_number_element_new) {
					cc_number_element_new.classList.remove(...cc_number_element_new.classList);
					cc_number_element_new.classList.add('pef-cc-field-container');
				}
				executeBankart();
			} else {
				executePayment();
			}
		}, 2000);
	});

	function executePayment() {
		clearInterval(bankartInterval);
		checkoutLoading.value = false;
	}

	let paymentjs = '';
	let numberFocused = false;
	let cvvFocused = false;
	let formStyleDesktop = {
		'border': '1px solid #D7E4EF',
		'height': '54px',
		'padding': '15px 20px 0',
		'background': 'transparent',
		'transition': 'border-color 0.3s',
		'font-size': '16px',
	};
	let formStyleMobile = {
		'border': '1px solid #D7E4EF',
		'height': '54px',
		'padding': '15px 15px 0',
		'background': 'transparent',
		'transition': 'border-color 0.3s',
		'font-size': '16px',
	};
	let formStyle = formStyleDesktop;
	let hoverStyle = {
		'border': '1px solid #8fbadf',
		'outline': '0',
		'transition': 'border-color 0.3s',
	};
	let focusStyle = {
		'border': '1px solid #8fbadf',
		'outline': '0',
		'transition': 'border-color 0.3s',
		'outline-width': '0',
	};
	let errorStyle = {
		'border-bottom': '2px solid #EB4C12',
		'transition': 'border-color 0.3s',
	};
	let successStyle = {
		'border-bottom': '2px solid #005DAC',
		'transition': 'border-color 0.3s',
	};
	function executeBankart() {
		clearInterval(bankartInterval);

		paymentjs = new PaymentJs();
		paymentjs.init(paymentgateway.value.shared_key, 'cc_number', 'cc_cvv', function (paymentjs) {
			checkoutLoading.value = false;
			formValid.value = 0;

			const cc_expire_month = document.getElementById('cc_expire_month-1');
			const cc_expire_year = document.getElementById('cc_expire_year-1');
			const cc_number = document.getElementById('cc_number-1');
			const cc_cvv = document.getElementById('cc_cvv-1');

			if(cc_expire_month) cc_expire_month.parentElement.style.visibility = 'hidden';
			if(cc_expire_year) cc_expire_year.parentElement.style.visibility = 'hidden';
			if(cc_number) cc_number.parentElement.style.visibility = 'hidden';
			if(cc_cvv) cc_cvv.parentElement.style.visibility = 'hidden';

			paymentjs.setNumberStyle(formStyle);
			paymentjs.setCvvStyle(formStyle);
			const error_cc_number = document.getElementById('error_cc_number');
			const bankartCvvLabel = document.getElementById('bankartCvvLabel');
			const bankartNumberLabel = document.getElementById('bankartNumberLabel');

			// Hover events
			paymentjs.numberOn('mouseover', function (data) {
				var numberLengthMouseover = data['numberLength'];

				if (!numberFocused && numberLengthMouseover == 0) {
					paymentjs.setNumberStyle(hoverStyle);
					if(error_cc_number) error_cc_number.style.display = 'none';
				}
			});
			paymentjs.numberOn('mouseout', function (data) {
				var validNumberMouseout = data['validNumber'];
				var numberLengthMouseover = data['numberLength'];

				if (!numberFocused && !validNumberMouseout && numberLengthMouseover == 0) {
					paymentjs.setNumberStyle(formStyle);
					if(error_cc_number) error_cc_number.style.display = 'none';
				}
			});

			paymentjs.cvvOn('mouseover', function (data) {
				var validCvvMouseover = data['validCvv'];
				var cvvLengthMouseover = data['cvvLength'];
				var cardType = data['cardType'];
				if (!cvvFocused && cvvLengthMouseover == 0) {
					paymentjs.setCvvStyle(hoverStyle);
				} else if (validCvvMouseover == true && (orderData.value.cart.indicators.payment_cart_type == null || (orderData.value.cart.indicators.payment_cart_type != null && cardType != orderData.value.cart.indicators.payment_cart_type))) {
					paymentjs.setCvvStyle(successStyle);
				} else if (validCvvMouseover == false) {
					paymentjs.setCvvStyle(errorStyle);
				}
			});
			paymentjs.cvvOn('mouseout', function (data) {
				if (!cvvFocused) {
					paymentjs.setCvvStyle(formStyle);
				}
				var validCvvMouseout = data['validCvv'];
				var cvvLengthMouseout = data['cvvLength'];
				if (validCvvMouseout == false && cvvLengthMouseout > 0) {
					paymentjs.setCvvStyle(errorStyle);
				}
				if (validCvvMouseout) {
					paymentjs.setCvvStyle(successStyle);
				}
			});

			// Focus events
			paymentjs.numberOn('focus', function (data) {
				if(bankartNumberLabel) bankartNumberLabel.parentElement.classList.add('floated-bankart');
				paymentjs.setNumberStyle(focusStyle);

				var validNumberFocus = data['validNumber'];
				var cardType = data['cardType'];
				var numberLengthFocus = data['numberLength'];

				if((cardType && cardType != 'visa_electron' && cardType != orderData?.value?.cart?.indicators?.payment_cart_type) || (cardType && cardType == 'visa_electron' && orderData?.value?.cart?.indicators?.payment_cart_type != 'visa')) {
					cardTypeValue.value = false;
				} else {
					cardTypeValue.value = true;
				}

				if (validNumberFocus == true && ((orderData.value.cart.indicators.payment_cart_type != null && cardType == orderData.value.cart.indicators.payment_cart_type) || (orderData.value.cart.indicators.payment_cart_type != null && cardType == 'visa_electron' && orderData.value.cart.indicators.payment_cart_type == 'visa') || orderData.value.cart.indicators.payment_cart_type == null)) {
					error_cc_number.style.display = 'none';
					paymentjs.setNumberStyle(successStyle);
				} else if (numberFocused == false) {
					error_cc_number.style.display = 'none';
					paymentjs.setNumberStyle(hoverStyle);
				} else if (validNumberFocus == false || (validNumberFocus == true && orderData.value.cart.indicators.payment_cart_type != null && cardType != orderData.value.cart.indicators.payment_cart_type) || (validNumberFocus == true && orderData.value.cart.indicators.payment_cart_type != null && cardType == 'visa_electron' && orderData.value.cart.indicators.payment_cart_type != 'visa')) {
					error_cc_number.style.display = 'block';
					paymentjs.setNumberStyle(errorStyle);
				} else if (validNumberFocus == null) {
					error_cc_number.style.display = 'block';
					paymentjs.setNumberStyle(errorStyle);
				} else if (numberLengthFocus == 0) {
					error_cc_number.style.display = 'none';
				}

				if (numberFocused == false) {
					numberFocused = true;
				}
			});

			paymentjs.cvvOn('focus', function (data) {
				if(bankartCvvLabel) bankartCvvLabel.parentElement.classList.add('floated-bankart');
				paymentjs.setCvvStyle(focusStyle);

				var validCvvFocus = data['validCvv'];
				var cvvLengthFocus = data['cvvLength'];
				if (validCvvFocus == true) {
					paymentjs.setCvvStyle(successStyle);
				} else if (cvvFocused == false) {
					paymentjs.setCvvStyle(hoverStyle);
				} else if (validCvvFocus == false) {
					paymentjs.setCvvStyle(errorStyle);
				}

				if (cvvLengthFocus > 0 && cvvFocused == false) {
					cvvFocused = true;
				}
			});

			// Blur events
			paymentjs.numberOn('blur', function (data) {
				if(bankartNumberLabel) bankartNumberLabel.parentElement.classList.remove('floated-bankart');

				var validNumberBlur = data['validNumber'];
				var cardType = data['cardType'];
				var numberLengthBlur = data['numberLength'];

				if((cardType && cardType != 'visa_electron' && cardType != orderData?.value?.cart?.indicators?.payment_cart_type) || (cardType && cardType == 'visa_electron' && orderData?.value?.cart?.indicators?.payment_cart_type != 'visa')) {
					cardTypeValue.value = false;
				} else {
					cardTypeValue.value = true;
				}

				if (validNumberBlur == true && ((orderData.value.cart.indicators.payment_cart_type != null && cardType == orderData.value.cart.indicators.payment_cart_type) || (orderData.value.cart.indicators.payment_cart_type != null && cardType == 'visa_electron' && orderData.value.cart.indicators.payment_cart_type == 'visa') || orderData.value.cart.indicators.payment_cart_type == null)) {
					error_cc_number.style.display = 'none';
					paymentjs.setNumberStyle(successStyle);
				} else if (numberFocused == false) {
					error_cc_number.style.display = 'none';
					paymentjs.setNumberStyle(formStyle);
				} else if (validNumberBlur == false || (validNumberBlur == true && orderData.value.cart.indicators.payment_cart_type != null && cardType != orderData.value.cart.indicators.payment_cart_type) || (validNumberBlur == true && orderData.value.cart.indicators.payment_cart_type != null && cardType == 'visa_electron' && orderData.value.cart.indicators.payment_cart_type != 'visa')) {
					error_cc_number.style.display = 'block';
					paymentjs.setNumberStyle(errorStyle);
				} else if (validNumberBlur == null) {
					error_cc_number.style.display = 'block';
					paymentjs.setNumberStyle(errorStyle);
				} else if (numberLengthBlur == 0) {
					error_cc_number.style.display = 'none';
				}

				validationBankart();
			});

			paymentjs.cvvOn('blur', function (data) {
				if(bankartCvvLabel) bankartCvvLabel.parentElement.classList.remove('floated-bankart');
				paymentjs.setCvvStyle(formStyle);

				var validCvvBlur = data['validCvv'];
				if (validCvvBlur == true) {
					paymentjs.setCvvStyle(successStyle);
				} else if (cvvFocused == false) {
					paymentjs.setCvvStyle(hoverStyle);
				} else if (validCvvBlur == false) {
					paymentjs.setCvvStyle(errorStyle);
				}

				validationBankart();
			});

			paymentjs.numberOn('input', function (data) {
				if(bankartNumberLabel) bankartNumberLabel.parentElement.classList.add('floated-bankart-b');
				var cardType = data['cardType'];
				var validNumber = data['validNumber'];
				var cc_number_element = document.getElementById('cc_number');
				var cc_expire_month_year = document.getElementById('exp_month_year');
				error_cc_number.style.display = 'none';
				paymentjs.setNumberStyle(formStyle);
				cardNumberValid.value = 0;

				if((cardType && cardType != 'visa_electron' && cardType != orderData?.value?.cart?.indicators?.payment_cart_type) || (cardType && cardType == 'visa_electron' && orderData?.value?.cart?.indicators?.payment_cart_type != 'visa')) {
					cardTypeValue.value = false;
				} else {
					cardTypeValue.value = true;
				}

				if ((validNumber && cardType && cardType != orderData?.value?.cart?.indicators?.payment_cart_type) || (validNumber && cardType && cardType == 'visa_electron' && cardType != 'visa')) {
					error_cc_number.style.display = 'block';
					paymentjs.setNumberStyle(errorStyle);
				}

				if ((validNumber && orderData.value.cart.indicators.payment_cart_type == null) || (validNumber && orderData.value.cart.indicators.payment_cart_type != null && cardType == orderData.value.cart.indicators.payment_cart_type) || (validNumber && orderData.value.cart.indicators.payment_cart_type != null && cardType == 'visa_electron' && orderData.value.cart.indicators.payment_cart_type == 'visa')) {
					error_cc_number.style.display = 'none';
					paymentjs.setNumberStyle(successStyle);
					cardNumberValid.value = 1;
				}

				if ((cardType && orderData.value.cart.indicators.payment_cart_type == null) || (cardType && orderData.value.cart.indicators.payment_cart_type != null && cardType == orderData.value.cart.indicators.payment_cart_type) || (cardType && orderData.value.cart.indicators.payment_cart_type != null && cardType == 'visa_electron' && orderData.value.cart.indicators.payment_cart_type == 'visa')) {
					cc_number_element.classList.remove(...cc_number_element.classList);
					cc_number_element.classList.add('pef-cc-field-container');
					cc_number_element.classList.add('active');
					cc_number_element.classList.add(cardType);
				} else {
					cc_number_element.classList.remove(...cc_number_element.classList);
					cc_number_element.classList.add('pef-cc-field-container');
				}

				validationBankart();
			});

			paymentjs.cvvOn('input', function (data) {
				if(bankartCvvLabel) bankartCvvLabel.parentElement.classList.add('floated-bankart-b');
				var validCvv = data['validCvv'];
				var cvvLength = data['cvvLength'];

				if (cvvLength > 0 && cvvFocused == false) {
					cvvFocused = true;
				}

				if (validCvv) {
					paymentjs.setCvvStyle(successStyle);
					cvvValid.value = 1;
				} else {
					paymentjs.setCvvStyle(errorStyle);
					cvvValid.value = 0;
				}

				validationBankart();
			});
		});

		let exp_date_spliter = '/';
		let exp_month_year = document.getElementById('exp_month_year');
		let exp_month_year_error = document.getElementById('error_exp_month_year');
		let exp_month = document.getElementById('cc_expire_month-1');
		let currentMonth = new Date().getMonth() + 1;
		let exp_month_min;
		let exp_month_max;
		if(exp_month) {
			exp_month?.setAttribute('min', '1');
			exp_month?.setAttribute('max', '12');
			exp_month_min = exp_month.getAttribute('min');
			exp_month_max = exp_month.getAttribute('max');
		}

		let exp_year = document.getElementById('cc_expire_year-1');
		let currentYear = new Date().getFullYear() - 2000;
		let exp_year_min;
		let exp_year_max;
		if(exp_year) {
			exp_year?.setAttribute('min', currentYear);
			exp_year?.setAttribute('max', currentYear + 10);
			exp_year_min = exp_year.getAttribute('min');
			exp_year_max = exp_year.getAttribute('max');
		}

		let exp_exist = false;
		let exp_valid = false;
		let exp_focus = false;

		function addStr(str, index, stringToAdd) {
			return str.substring(0, index) + stringToAdd + str.substring(index, str.length);
		}

		if(exp_month_year) {
			// keyCode: 8 - backspace, 37 - left, 39 - right, 46 - delete
			exp_month_year.addEventListener('keyup', event => {
				let exp_month_year_value = exp_month_year.value;
				exp_exist = false;
				exp_valid = false;
				exp_focus = true;

				if (exp_month_year_value.length) {
					exp_exist = true;
				}

				// add separator
				const add_exp_date_splitter_pattern = /^\d{3}/i;
				if (exp_month_year_value.match(add_exp_date_splitter_pattern)) {
					exp_month_year.value = addStr(exp_month_year_value, 2, exp_date_spliter);
					return;
				}

				// remove separator
				if (exp_month_year_value.length == 2 + exp_date_spliter.length && event.keyCode == 8) {
					const new_exp_month_year_value = exp_month_year_value.replace(exp_date_spliter, '');
					exp_month_year.value = new_exp_month_year_value;
					exp_month_year_value = new_exp_month_year_value;
				}

				if (exp_focus != false) {
					exp_month_year.parentElement.classList.add('field-error');
					exp_month_year.parentElement.classList.remove('field-success');
					if(exp_month_year_error) exp_month_year_error.style.display = 'block';
				}

				if (exp_month_year_value.length == 4 + exp_date_spliter.length) {
					let exp_month_year_value_single = exp_month_year_value.split(exp_date_spliter);

					let exp_month_value = exp_month_year_value_single[0];
					let exp_year_value = exp_month_year_value_single[1];

					if (
						(parseInt(exp_year_value, 10) == exp_year_min && parseInt(exp_month_value, 10) >= currentMonth && parseInt(exp_month_value, 10) <= exp_month_max) ||
						(parseInt(exp_year_value, 10) > exp_year_min && parseInt(exp_month_value, 10) >= exp_month_min && parseInt(exp_month_value, 10) <= exp_month_max && parseInt(exp_year_value, 10) >= exp_year_min && parseInt(exp_year_value, 10) <= exp_year_max)
					) {
						exp_month.value = exp_month_value;
						creditCard.value[3].value = exp_month_value;
						exp_year.value = exp_year_value;
						creditCard.value[4].value = exp_year_value;
						dateValid.value = 1;

						exp_month_year.parentElement.classList.remove('field-error');
						exp_month_year.parentElement.classList.add('field-success');
						if(exp_month_year_error) exp_month_year_error.style.display = 'none';

						exp_valid = true;
					} else {
						exp_month_year.parentElement.classList.add('field-error');
						exp_month_year.parentElement.classList.remove('field-success');
						if(exp_month_year_error) exp_month_year_error.style.display = 'block';
						dateValid.value = 0;
					}
				}

				validationBankart();
			});

			exp_month_year.addEventListener('focus', e => {
				exp_month_year.parentElement.classList.add('floated-label');
			});

			exp_month_year.addEventListener('blur', e => {
				if (exp_exist && exp_valid) {
					exp_month_year.parentElement.classList.remove('field-error');
					if(exp_month_year_error) exp_month_year_error.style.display = 'none';
				} else if (exp_exist && !exp_valid) {
					exp_month_year.parentElement.classList.add('field-error');
					exp_month_year.parentElement.classList.remove('field-success');
					if(exp_month_year_error) exp_month_year_error.style.display = 'block';
				} else if (exp_focus != false) {
					exp_month_year.parentElement.classList.add('field-error');
					exp_month_year.parentElement.classList.remove('field-success');
					if(exp_month_year_error) exp_month_year_error.style.display = 'block';
				} else if (exp_exist == false) {
					exp_month_year.parentElement.classList.remove('floated-label');
				}
			});
		}
	}

	onMounted(() => {
		const url = window.location.href;
		const searchParams = new URL(url).searchParams;

		if (orderSuccess.value == 0 && additionalPaymentRoute.value == 0 && searchParams.get('webshopadditionalpayment')) {
			additionalPaymentRoute.value = 1;
			const urlId = searchParams.get('order_identificator');
			const webshopOrderId = endpoints.get('_get_hapi_webshop_additionalpayment');
			const webshopOrder = webshopOrderId.replace('%ID%-%CODE%', urlId);

			async function orderDataFunction() {
				await useApi(webshopOrder, {method: 'GET'})
				.then(async res => {
					additionalPayment.value = res.data;
					orderData.value = res.data;

					if (res.data.cart.payment_type == 'credit_cart_form') {
						const paymentgatewayId = endpoints.get('_get_hapi_webshop_additionalpayment_specific_paymentgateway_data');
						const paymentgatewayData = paymentgatewayId.replace('%ID%-%CODE%', urlId);
						await useApi(paymentgatewayData, {method: 'GET'})
						.then(async res => {
							paymentgateway.value = res.data;
							let pgMode = paymentgateway.value.pg_mode;
							let pgModeFillFields = 'phone_email';
							if (pgMode == 'cc') {
								pgModeFillFields = 'cc_first_name,cc_last_name';
							}
							let apiExtraValue = '?type=webshop.' + pgMode + '&order_identificator=' + urlId + '-webshopadditionalpayment&fill_fields=' + pgModeFillFields + '&change_fields=cc_number:ignore_validation=1,cc_number:type=hidden,cc_cvv:ignore_validation=1,cc_cvv:type=hidden,cc_expire_month:ignore_validation=1,cc_expire_month:type=hidden,cc_expire_year:ignore_validation=1,cc_expire_year:type=hidden';
							await useApi(`${endpoints.get('_get_hapi_customer_fields')}${apiExtraValue}`)
							.then(res => (creditCard.value = res.data));
							if (res.success && paymentgateway.value && paymentgateway.value.pg_mode == 'cc') {
								bankartScript();
							}
						});
					}
				});

				checkoutLoading.value = true;
			}
			orderDataFunction();
		}

		if (orderSuccess.value == 0 && additionalPaymentRoute.value == 0 && searchParams.get('order_identificator')) {
			const urlId = searchParams.get('order_identificator');
			const webshopOrderId = endpoints.get('_get_hapi_webshop_order');
			const webshopOrder = webshopOrderId.replace('%ID%-%CODE%', urlId);

			async function orderDataFunction() {
				await useApi(webshopOrder, {method: 'GET'})
				.then(async res => {
					orderData.value = res.data;

					if (res.data.cart.payment_type == 'credit_cart_form') {
						const paymentgatewayId = endpoints.get('_get_hapi_webshop_order_specific_paymentgateway_data');
						const paymentgatewayData = paymentgatewayId.replace('%ID%-%CODE%', urlId);
						await useApi(paymentgatewayData, {method: 'GET'})
						.then(async res => {
							paymentgateway.value = res.data;
							let pgMode = paymentgateway.value.pg_mode;
							let pgModeFillFields = 'phone_email';
							if (pgMode == 'cc') {
								pgModeFillFields = 'cc_first_name,cc_last_name';
							}
							let apiExtraValue = '?type=webshop.' + pgMode + '&order_identificator=' + urlId + '&fill_fields=' + pgModeFillFields + '&change_fields=cc_number:ignore_validation=1,cc_number:type=hidden,cc_cvv:ignore_validation=1,cc_cvv:type=hidden,cc_expire_month:ignore_validation=1,cc_expire_month:type=hidden,cc_expire_year:ignore_validation=1,cc_expire_year:type=hidden';
							await useApi(`${endpoints.get('_get_hapi_customer_fields')}${apiExtraValue}`)
							.then(res => (creditCard.value = res.data));
							if (res.success && paymentgateway.value && paymentgateway.value.pg_mode == 'cc') {
								bankartScript();
							}
						});
					}
				});

				checkoutLoading.value = true;
			}
			orderDataFunction();
		}

		orderSuccess.value = 0;
	});

	async function onSubmit(values) {
		checkoutLoading.value = true;
		let creditCardFields = values?.values;
		if (paymentgateway.value.pg_mode == 'cc') {
			creditCardFields['cc_expire_month'] = creditCard.value[3].value;
			creditCardFields['cc_expire_year'] = creditCard.value[4].value;
		}
		creditCardFields['_change_fields'] = 'cc_number:ignore_validation=1,cc_number:type=hidden,cc_cvv:ignore_validation=1,cc_cvv:type=hidden,cc_expire_month:ignore_validation=1,cc_expire_month:type=hidden,cc_expire_year:ignore_validation=1,cc_expire_year:type=hidden';
		let pgMode = paymentgateway.value.pg_mode;
		let apiExtraValue = '?type=webshop.' + pgMode;

		await useApi(`${endpoints.get('_post_hapi_customer')}${apiExtraValue}`, {method: 'POST', body: creditCardFields})
		.then(async res => {
			if (res.success) {
				const id_code = additionalPaymentRoute.value == 1 ? orderData.value.cart.id + '-' + orderData.value.cart.code : orderData.value.cart.order_id + '-' + orderData.value.cart.order_code;
				const epBankartPayment = additionalPaymentRoute.value == 1 ? endpoints.get('_put_hapi_webshop_additionalpayment_prepare_paymentgateway') : endpoints.get('_put_hapi_webshop_order_prepare_paymentgateway');
				const prepareBankartPayment = epBankartPayment.replace('%ID%-%CODE%', id_code);
				let bankart_payment_data = '';

				function interceptSubmit() {
					const data = {
						first_name: orderData.value.customer.first_name,
						last_name: orderData.value.customer.last_name,
						month: creditCardFields?.cc_expire_month,
						year: creditCardFields?.cc_expire_year,
						email: orderData.value.customer.email,
						order_id: paymentgateway.value.order_id,
						hold_url: paymentgateway.value.payment_hold_url,
						cancel_url: paymentgateway.value.cancel_url,
					};

					paymentjs.tokenize(
						data, //additional data, MUST include card_holder (or first_name & last_name), month and year
						async function (token, cardData) {
							//success callback function
							let bankart_payment_data = {
								'cc_type': cardData.card_type,
								'first_name': data.first_name,
								'last_name': data.last_name,
								'cc_exp_month': data.month,
								'cc_exp_year': data.year,
								'email': data.email,
								'token': token,
								'order_id': data.order_id,
								'hold_url': data.hold_url,
								'cancel_url': data.cancel_url,
							};

							await useApi(prepareBankartPayment, {method: 'PUT', body: bankart_payment_data}, {appendLang: false})
							.then(res => {
								if (res.success) {
									const link = res.data.redirect_option;
									window.location.href = link;
								} else {
									paymentError.value = res.data;
									formValid.value = 0;
									checkoutLoading.value = false;
								}
							});
						}
					);
				}

				if (paymentgateway.value.pg_mode == 'cc') {
					interceptSubmit();
				} else {
					let payment_data = {
						'phone_email': creditCardFields?.phone_email,
						'order_id': paymentgateway.value.order_id,
						'hold_url': paymentgateway.value.payment_hold_url,
						'cancel_url': paymentgateway.value.cancel_url,
					};

					await useApi(prepareBankartPayment, {method: 'PUT', body: payment_data}, {appendLang: false})
					.then(res => {
						checkoutLoading.value = true;
						if (res.success) {
							const link = res.data.redirect_option;
							window.location.href = link;
							checkoutLoading.value = false;
						} else {
							paymentError.value = res.data;
							checkoutLoading.value = false;
						}
					});
				}
			}
		});
	}

	//gtm
	const gtm = useGtmBB();

	function onPageLoad(data) {
		if(!data) return;
		gtm.pageView({
			url: data?.url || '',
			title: data?.title || '',
		});
	}
</script>

<style lang="less" scoped>
	* {
		--sideOffset: 40px;
	}
	@media (max-width: @t) {
		* {
			--sideOffset: 25px;
		}
	}
	@media (max-width: @m) {
		* {
			--sideOffset: 20px;
		}
		.btn {
			height: 54px;
			font-size: 16px;
			line-height: 1;
		}
		.btn-icon-arrow span:before {
			top: 4px;
			font-size: 9px;
		}
	}

	.wc-payment-second-form {
		margin-top: 30px;

		@media (max-width: @m) {
			margin-top: 15px;
		}
	}

	.wc-subtitle {
		display: block;
		margin: 20px 0 12px;
		font-size: 17px;
		font-weight: 600;

		@media (max-width: @m) {
			margin: 15px 0 10px;
			font-size: 15px;
		}
	}

	.wc-fields {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		grid-column-gap: 20px;
		&.special {
			display: block;
			grid-column-gap: 0;
			max-width: 440px;
		}

		:deep(iframe){height: 54px;}
		div {
			display: flex;
			width: auto;
			flex-grow: 1;
		}
		& > div:first-child {
			grid-area: 1 / 1 / 2 / 3;
		}
		& > div:nth-child(2) {
			grid-area: 1 / 3 / 2 / 5;
		}
		& > div:nth-child(7) {
			grid-area: 2 / 1 / 3 / 3;
		}
		& > div:nth-child(8) {
			grid-area: 2 / 3 / 3 / 4;
		}
		& > div:nth-child(9) {
			grid-area: 2 / 4 / 3 / 5;
		}

		@media (max-width: @ms) {
			grid-template-columns: repeat(2, 1fr);
			grid-column-gap: 15px;
			&.special {
				max-width: unset;
			}

			& > div:first-child {
				grid-area: 1 / 1 / 2 / 3;
			}
			& > div:nth-child(2) {
				grid-area: 2 / 1 / 3 / 3;
			}
			& > div:nth-child(7) {
				grid-area: 3 / 1 / 4 / 3;
			}
			& > div:nth-child(8) {
				grid-area: 4 / 1 / 5 / 2;
			}
			& > div:nth-child(9) {
				grid-area: 4 / 2 / 5 / 3;
			}
		}
	}
	.wc-fields-note {
		display: block;
		margin-top: -10px;
		margin-bottom: 25px;
		font-size: 14px;
		color: @inputTextColor;

		@media (max-width: @m) {
			margin-top: -5px;
			line-height: 1.5;
		}
	}
	.bankart-label {
		z-index: -1;
	}
	.pef-cc-field-container {
		position: relative;
		&:before {
			width: 40px;
			height: 26px;
			position: absolute;
			top: 14px;
			right: 20px;
			z-index: 1;
			opacity: 0;
		}
		&.active:before {
			opacity: 1;
		}
		&.visa:before {
			content: '';
			background: url(/images/visa.svg) no-repeat;
			background-size: contain;
		}
		&.visa_electron:before {
			content: '';
			background: url(/images/visa.svg) no-repeat;
			background-size: contain;
		}
		&.maestro:before {
			content: '';
			background: url(/images/maestro.svg) no-repeat;
			background-size: contain;
		}
		&.mastercard:before {
			content: '';
			background: url(/images/master.svg) no-repeat;
			background-size: contain;
		}
		&.diners:before {
			content: '';
			background: url(/images/diners.svg) no-repeat;
			background-size: contain;
		}
		&#cc_cvv:before {
			content: '';
			width: 30px;
			height: 24px;
			background: url(/images/cvv.svg) no-repeat;
			background-size: contain;
			top: 17px;
		}

		@media (max-width: @m) {
			&:before {
				top: 15px;
				right: 15px;
			}
		}
	}
	.floated-bankart,
	.floated-bankart-b {
		label {
			font-size: 12px;
			top: 7px;
		}
	}
	.cvv-info-label {
		display: block;
		padding: 0 10px;
		font-size: 12px;
		line-height: 1.4;
		font-weight: normal;
		text-align: center;
		position: absolute;
		top: calc(~'100% - -10px');

		@media (max-width: @m) {
			padding: 0 5px;
		}
	}
</style>
